async function helloSleepy(){
  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  
  console.log("hello");
  await sleep(1000);

  const elements = document.getElementsByClassName("price-label");

  console.log(elements.length);
  for (let i = 0; i < elements.length; i++) {
      elements[i].innerHTML = "<span class='money'>" + elements[i].innerHTML + "</span>";
  }
}

helloSleepy();